export default "__VITE_ASSET__B1WFOoT1__"